import {
	PropsWithChildren,
	ReactElement,
	useContext
} from "react";
import styles from "./ReorderableList.module.less";
import classNames from "classnames";
import { ReorderableListItemContext } from "./ReorderableListItemContext";


export const ReorderableListDragIndicator = (
	props: PropsWithChildren<{}>
): ReactElement => {
	const { children } = props;

	const {
		isDragging
	 } = useContext(ReorderableListItemContext);

	return (
		<div
			className={classNames(
				styles.dragIndicator,
				{
					[styles.dragIndicator_isDragging]: isDragging
				}
			)}
		>
			{children}
		</div>
	);
};

ReorderableListDragIndicator.displayName = "ReorderableList.DragIndicator";